/* global fbq */

import React, { useEffect, useState } from 'react'
import { useAuth } from '../../../../contexts/AuthContext.js';

import axios from 'axios';

import { Addons, Champions, Roles } from '../../../../components/GeneralContainers.js';
import Loading from '../../../../components/Loading.js';
import { ORDER_STATUS, BOOST_TYPE } from '../../../../constants/database_values.js';
import { useParams, useNavigate } from 'react-router-dom';
import ProgressBar from "@ramonak/react-progress-bar";

export default function ActiveNormalBoost() {

    const [loading, setLoading] = useState(false);
    const [order, setOrder] = useState(null);

    const { order_id } = useParams();
    const { getAccessToken } = useAuth();
    const navigate = useNavigate();

    const pushToDataLayer = (payload) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    };

    useEffect(() => {
        if(!order_id) return;
        axios.get(process.env.REACT_APP_API_URL + '/user/boost-order-information/' + order_id, {
            headers: {
                Authorization: getAccessToken()
            },
            params: {
                boost_type: BOOST_TYPE.NORMAL_GAMES,
                order_status: ORDER_STATUS.ACTIVE
            }
        }).then(response => {
            setOrder(response.data);
            setLoading(false);
            const productSaleEvent = localStorage.getItem('productSaleEvent');
            if(productSaleEvent && productSaleEvent === response.data.order_id) {
                // If the productSaleEvent is already set and matches the current order_id, do not track again
                return;
            }
            if (typeof fbq !== 'undefined') {
                fbq('track', 'Purchase', {
                    order_id: order_id,
                    value: response.data.total_price.toFixed(2),
                    currency: 'USD',
                });
            }
            pushToDataLayer({
                event: 'purchase',
                value: parseFloat(response.data.total_price),
                currency: 'USD',
                transaction_id: order_id,
                ecommerce: {
                  transaction_id: order_id,
                  value: parseFloat(response.data.total_price),
                  currency: 'USD'
                }
            })
            localStorage.setItem('productSaleEvent', order_id);
        }).catch(error => {
            console.error(error);
            setLoading(false);
        });
    }, [order_id]);

    
    if(!order) return(
        <>
            <div className='active-order normal-games'/>
            <Loading loading={loading} panel={true}/>
        </>
    );

    const pct = Math.max(0, Math.min(order.progress, 100))

    return (
    <div className="flex flex-col flex-1 min-h-0 overflow-y-auto">
      <div className="flex flex-col flex-1 bg-[var(--bg-surface)] border border-[var(--border)] rounded-t-lg rounded-b-none p-6 text-white space-y-6">

        {/* Header Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="flex flex-col items-center rounded-lg">
            <h4 className="text-md font-medium text-[var(--secondary-text)]">Order Type</h4>
            <p className="text-sm font-semibold">{order.order_type}</p>
          </div>
          <div className="flex flex-col items-center rounded-lg">
            <h4 className="text-md font-medium text-[var(--secondary-text)]">
              {order.order_type === 'Total Wins' ? 'Total Wins' : 'Total Games'}
            </h4>
            <p className="text-sm font-semibold">{order.total_games}</p>
          </div>
          <div className="flex flex-col items-center rounded-lg">
            <h4 className="text-md font-medium text-[var(--secondary-text)]">Queue Type</h4>
            <p className="text-sm font-semibold">Draft Mode</p>
          </div>
        </div>

        {/* Progress + CTA */}
        <ProgressBar
          completed={pct}
          className="w-full rounded-full overflow-hidden"
          bgColor="var(--main)"
        />
        <div className="flex space-x-4">
            <button
                className="flex-1 py-3 bg-[var(--main)] hover:bg-opacity-90 text-white font-bold rounded-lg"
                onClick={() =>
                navigate(
                    `/my-orders/boosting/account-information/normal-games/${order_id}`
                )
                }
            >
                Account Information
            </button>
            <button
                className="flex-1 py-3 bg-[var(--main)] hover:bg-opacity-90 text-white font-bold rounded-lg"
                onClick={() =>
                navigate(`/my-orders/messages/${order_id}`)
                }
            >
                Chat
            </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 flex-shrink-0">
          <div className="flex flex-col gap-2">
            <h4 className="text-md font-medium text-[var(--secondary-text)]">Total Price</h4>
            <p className="text-sm font-semibold">${order.total_price.toFixed(2)} USD</p>
          </div>
          <div className="flex flex-col gap-2">
            <h4 className="text-md font-medium text-[var(--secondary-text)]">Add-ons</h4>
            <Addons elements={order.addons} />
          </div>
          {order.roles?.length > 0 && (
            <div className="flex flex-col gap-2">
              <h4 className="text-md font-medium text-[var(--secondary-text)]">Roles</h4>
              <Roles elements={order.roles} />
            </div>
          )}
          {order.champions?.length > 0 && (
            <div className="flex flex-col gap-2">
              <h4 className="text-md font-medium text-[var(--secondary-text)]">Champions</h4>
              <Champions elements={order.champions} />
            </div>
          )}
          {order.notes && (
            <div className="flex flex-col gap-2 break-words">
              <h4 className="text-md font-medium text-[var(--secondary-text)]">Notes</h4>
              <p className="text-sm">{order.notes}</p>
            </div>
          )}
        </div>
      </div>
      <Loading loading={loading} panel />
    </div>
  )
}